/**
 * Returns true if the value is a valid S3 URI (s3://bucket/key).
 */
export const isS3Link = (value: string): boolean => {
  return /^s3:\/\/[^/]+\/.+$/.test(value);
};

/**
 * Strips the bucket prefix from an S3 URI and returns the object key.
 * Returns the original value unchanged if it is not a valid S3 URI.
 *
 * @example
 * extractS3Key("s3://my-bucket/path/to/file.txt") // → "path/to/file.txt"
 * extractS3Key("not-a-uri")                        // → "not-a-uri"
 */
export const extractS3Key = (value: string): string => {
  const match = value.match(/^s3:\/\/[^/]+\/(.+)$/);
  return match ? match[1] : value;
};

/**
 * Extracts the bucket name from an S3 URI.
 * Returns null if the value is not a valid S3 URI.
 *
 * @example
 * extractS3Bucket("s3://my-bucket/path/to/file.txt") // → "my-bucket"
 * extractS3Bucket("not-a-uri")                        // → null
 */
export const extractS3Bucket = (value: string): string | null => {
  const match = value.match(/^s3:\/\/([^/]+)\//);
  return match ? match[1] : null;
};

/**
 * Returns true if the selected S3 file is a zip whose location has already
 * been resolved to an S3 URI, meaning the pipeline service can download the
 * archive itself instead of the client downloading and re-uploading it.
 */
export const isResolvedZipS3Source = (
  s3FileKey?: string | null,
  s3Uri?: string | null
): boolean => {
  return Boolean(s3FileKey?.endsWith(".zip") && s3Uri);
};
